"use client";

import React from "react";
import { ArrowRight, CirclePlay, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ModernRealEstateHub() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="30880" id="the-feature-set" ref={ref} className="relative w-full overflow-hidden bg-background py-24 lg:py-32 dark">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-3/4 h-full bg-gradient-to-l from-primary/10 to-transparent opacity-30" />
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
      </div>

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            {}
            <Badge variant="outline" className="rounded-sm px-4 py-1.5 border-primary/40 text-primary bg-primary/10 text-xs font-bold tracking-widest uppercase hover:bg-primary/20 transition-colors">
              The Social Split
              <ArrowRight className="ml-2 h-3.5 w-3.5" />
            </Badge>

            {}
            <h1 className="text-5xl sm:text-6xl lg:text-[72px] font-black tracking-tighter text-foreground leading-[1.05]">
              Designed for <br />
              <span className="text-primary">the City.</span>
            </h1>

            {}
            <p className="text-xl text-muted-foreground max-w-xl leading-relaxed font-medium">
              HalfOrder connects you with people nearby to share meals and split the bill. 
              The smartest way for Toronto students and pros to eat premium for half the price.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto pt-2">
              <Button asChild size="lg" className="h-14 px-8 text-base rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl shadow-primary/30 transition-all hover:-translate-y-0.5">
                <Link to="/DownloadPage">
                  Download App
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base rounded-sm border-primary text-primary hover:bg-primary/5 hover:text-primary transition-all hover:-translate-y-0.5">
                <Link to="/HowItWorksPage">
                  <CirclePlay className="mr-2 h-5 w-5" />
                  Watch Demo
                </Link>
              </Button>
            </div>

            {}
            <div className="pt-6 flex items-center gap-6 text-sm text-muted-foreground font-mono">
              <div className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-primary" />
                <span>Split costs instantly</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-primary" />
                <span>Save up to 50%</span>
              </div>
            </div>
          </div>

          {}
          <div className={`relative w-full max-w-lg lg:max-w-none mx-auto lg:mx-0 transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute inset-0 bg-gradient-to-tr from-background via-transparent to-transparent z-10" />
            <div className="absolute -inset-4 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/nestlink_architectural_blur.png')] bg-cover bg-center rounded-sm opacity-20 blur-md scale-105" />

            {}
            <div className="relative z-20 transform transition-transform hover:scale-[1.01] duration-500">
              <div className="relative rounded-sm overflow-hidden shadow-2xl shadow-primary/20 border border-white/10 bg-card/40 backdrop-blur-md">
                 <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/nestlink_hero_smartphone_ui.png" alt="HalfOrder Mobile Interface" className="w-full h-auto object-cover block grayscale-[0.2] contrast-[1.1]" width={800} height={1000} />
                
                {}
                <div className="absolute -bottom-6 -left-6 bg-card p-5 rounded-sm shadow-2xl border border-primary/20 max-w-[220px] hidden sm:block animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500 fill-mode-forwards">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="h-8 w-8 rounded-sm bg-primary flex items-center justify-center text-primary-foreground font-black text-xs">
                      HO
                    </div>
                    <div>
                      <div className="text-xs font-bold text-foreground tracking-tight">Order Matched</div>
                      <div className="text-[10px] font-mono text-primary uppercase">Savings: $14.50</div>
                    </div>
                  </div>
                  <div className="h-1.5 w-full bg-muted rounded-full overflow-hidden">
                    <div className="h-full bg-primary w-full rounded-full" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}